"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cacheReferrerEmail = exports.referral = exports.verify = exports.getStatus = exports.setOpen = exports.setPreOpen = exports.INCENTIVE_CACHE_REFERRER = exports.INCENTIVE_REFERRAL = exports.INCENTIVE_VERIFY = exports.INCENTIVE_STATUS = exports.INCENTIVE_OPEN = exports.INCENTIVE_PRE_OPEN = exports.INCENTIVE = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ajax = require("./ajax");

var _reduxActions = require("redux-actions");

var INCENTIVE = 'INCENTIVE';
exports.INCENTIVE = INCENTIVE;
var INCENTIVE_PRE_OPEN = "".concat(INCENTIVE, "::PRE_OPEN");
exports.INCENTIVE_PRE_OPEN = INCENTIVE_PRE_OPEN;
var INCENTIVE_OPEN = "".concat(INCENTIVE, "::OPEN");
exports.INCENTIVE_OPEN = INCENTIVE_OPEN;
var INCENTIVE_STATUS = "".concat(INCENTIVE, "::STATUS");
exports.INCENTIVE_STATUS = INCENTIVE_STATUS;
var INCENTIVE_VERIFY = "".concat(INCENTIVE, "::VERIFY");
exports.INCENTIVE_VERIFY = INCENTIVE_VERIFY;
var INCENTIVE_REFERRAL = "".concat(INCENTIVE, "::REFERRAL");
exports.INCENTIVE_REFERRAL = INCENTIVE_REFERRAL;
var INCENTIVE_CACHE_REFERRER = "".concat(INCENTIVE, "::CACHE_REFERRER");
exports.INCENTIVE_CACHE_REFERRER = INCENTIVE_CACHE_REFERRER;
var SERVICE_INCENTIVE_CONTEXT = "/service-incentive/secure/api/v1";
var EXTERNAL_SERVICE_INCENTIVE_CONTEXT = "/service-incentive/external/api/v1";
/**
 * User has accepted the incentive offer.
 *
 * @param {String} incentiveUuid
 * @param {String} productType - 'HELOC'
 */

var setPreOpen = function setPreOpen(incentiveUuid, productType) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxPost)(INCENTIVE_PRE_OPEN, dispatch, "".concat((0, _ajax.baseUrl)()).concat(SERVICE_INCENTIVE_CONTEXT, "/preopen"), {
                incentiveUuid: incentiveUuid,
                productType: productType
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/**
 * User has cleared the incentive offer conditions
 *
 * @param {String} incentiveUuid
 * @param {String} applicationUuid
 * @param {String} referrerEmail
 * @param {String} productType - 'HELOC'
 * @param {Boolean} dispatchHttpActions - true
 */


exports.setPreOpen = setPreOpen;

var setOpen = function setOpen(incentiveUuid, applicationUuid, referrerEmail, incentiveCode, productType) {
  var dispatchHttpActions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(dispatch) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", (0, _ajax.ajaxPost)(INCENTIVE_OPEN, dispatch, "".concat((0, _ajax.baseUrl)()).concat(SERVICE_INCENTIVE_CONTEXT, "/open"), {
                incentiveUuid: incentiveUuid,
                applicationUuid: applicationUuid,
                referrerEmail: referrerEmail,
                incentiveCode: incentiveCode,
                productType: productType
              }, null, null, dispatchHttpActions));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
/**
 * Get incentive offer status.
 *
 * @param {String} productType - 'HELOC'
 * @param {Boolean} dispatchHttpActions - true
 */


exports.setOpen = setOpen;

var getStatus = function getStatus(productType) {
  var dispatchHttpActions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(dispatch) {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", (0, _ajax.ajaxGet)(INCENTIVE_STATUS, dispatch, "".concat((0, _ajax.baseUrl)()).concat(SERVICE_INCENTIVE_CONTEXT, "/current/").concat(productType), null, null, dispatchHttpActions));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
/**
 * Confirms the validity of and incentive and/or code pair for external users.
 *
 * @param {String} incentiveUuid
 * @param {String} incentiveCode
 * @param {Boolean} dispatchHttpActions - true
 *
 */


exports.getStatus = getStatus;

var verify = function verify(incentiveUuid, incentiveCode) {
  var dispatchHttpActions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(dispatch) {
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", (0, _ajax.ajaxPost)(INCENTIVE_VERIFY, dispatch, "".concat((0, _ajax.baseUrl)()).concat(EXTERNAL_SERVICE_INCENTIVE_CONTEXT, "/verify"), {
                incentiveCode: incentiveCode,
                incentiveUuid: incentiveUuid
              }, null, null, dispatchHttpActions));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
/**
 * Lets a logged-in user send a referral email
 *
 * @param {String} incentiveUuid
 * @param {String} email
 */


exports.verify = verify;

var referral = function referral(incentiveUuid, email) {
  var dispatchHttpActions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(dispatch) {
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", (0, _ajax.ajaxPost)(INCENTIVE_REFERRAL, dispatch, "".concat((0, _ajax.baseUrl)()).concat(SERVICE_INCENTIVE_CONTEXT, "/referral"), {
                incentiveUuid: incentiveUuid,
                email: email
              }, null, null, dispatchHttpActions));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
/**
 * Caches the last email attempted to verify a referral. When user is not authenticated and attempts to
 * verify a referral without an incentiveCode or incentiveUuid in storage or query parameters, setOpen
 * should be called with the cached email when user is authenticated.
 */


exports.referral = referral;
var cacheReferrerEmail = (0, _reduxActions.createAction)(INCENTIVE_CACHE_REFERRER);
exports.cacheReferrerEmail = cacheReferrerEmail;